/**
 * StudentPasswordScreen — « Mot de passe » de l'élève (route `account-password`), à la place de
 * `student/account/UpdatePasswordScreen.js` quand l'espace élève est allumé.
 *
 * Rien à lire dans le store : la page ne porte que ce que l'élève tape (`useStudentPasswordState`).
 */
import React from "react"

import { StudentPasswordPage } from "../../../../../../design-system/student"
import { useStudentPasswordState } from "./useStudentPasswordState"

export function StudentPasswordScreen() {
    const state = useStudentPasswordState()

    return <StudentPasswordPage {...state} />
}
